/* =========================================================================
   OLINMAN 3 IN 1 — sayfa etkileşimleri (önek: ost26)
   Tüm fiyat/paket bilgisi campaign-config.js'ten okunur.
   NOT (Shopify): Bu dosyada sabit görsel yolu YOKTUR. Görseller HTML'de
   (src / data-hg / data-sap-img / data-pk-img-N) durur.
   ========================================================================= */
(function () {
  'use strict';
  var KOK = document.querySelector('.ost26'); if (!KOK) return;
  var CFG = window.OST_CAMPAIGN || {};
  var PK = CFG.packages || [];
  var idx = Math.min(CFG.defaultIndex || 0, PK.length - 1);
  var URUN = 'Olinman 3 in 1';

  var $ = function (s, k) { return (k || KOK).querySelector(s); };
  var $$ = function (s, k) { return Array.prototype.slice.call((k || KOK).querySelectorAll(s)); };
  function tl(n) { return n.toLocaleString('tr-TR', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' TL'; }
  function yaz(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

  var birim = PK[0] ? PK[0].price / PK[0].adet : 0;
  function kazanc(p) { return Math.max(0, Math.round(birim * p.adet - p.price)); }
  function yuzde(p) { return Math.round(kazanc(p) / (birim * p.adet) * 100); }

  /* paket görselleri HTML'den (Shopify'da asset_url'e çevrilir) */
  var modalEl = $('[data-modal]');
  function pkImg(p) { return (modalEl && modalEl.getAttribute('data-pk-img-' + p.adet)) || ''; }

  /* ---------------- Paket çipleri ---------------- */
  function cipleriCiz() {
    $$('[data-paket-cip]').forEach(function (kap) {
      kap.innerHTML = '';
      PK.forEach(function (p, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cip'; b.setAttribute('role', 'radio');
        b.innerHTML = (p.best ? '<small>Avantajlı</small>' : '') + '<b>' + p.adet + ' ' + (CFG.unit || 'Adet') + '</b><span>' + tl(p.price) + '</span>';
        b.addEventListener('click', function () { sec(i); });
        kap.appendChild(b);
      });
    });
    var mk = $('[data-m-paketler]');
    if (mk) {
      mk.innerHTML = '';
      PK.forEach(function (p, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'm-paket'; b.setAttribute('role', 'radio');
        var k = kazanc(p), im = pkImg(p);
        b.innerHTML = (p.best ? '<span class="mp-rozet">En avantajlı</span>' : '') +
          '<span class="mp-radyo" aria-hidden="true"></span>' +
          (im ? '<img src="' + im + '" alt="">' : '') +
          '<span><b>' + p.adet + ' ' + (CFG.unit || 'Adet') + '</b><small>' + (p.label || '') + '</small></span>' +
          '<span class="mp-fiyat"><strong>' + tl(p.price) + '</strong><em>' + (k ? k + ' TL cebinde' : 'Kargo bedava') + '</em></span>';
        if (p.available === false) { b.disabled = true; b.classList.add('tukendi'); }
        b.addEventListener('click', function () { sec(i); formYukle(); });
        mk.appendChild(b);
      });
    }
  }

  /* ---------------- Seçili paketi her yere yaz ---------------- */
  function guncelle() {
    var p = PK[idx]; if (!p) return;
    var adet = p.adet + ' ' + (CFG.unit || 'Adet');
    yaz('[data-fiyat]', tl(p.price));
    yaz('[data-adet-yazi-buyuk]', adet.toLocaleUpperCase('tr-TR'));
    var k = kazanc(p), y = yuzde(p);
    $$('[data-tasarruf-pill]').forEach(function (el) { el.hidden = !k; el.textContent = '-%' + y; });
    yaz('[data-tk-not]', k ? 'Tanesi ' + tl(p.price / p.adet) + ' · ' + k + ' TL cebinde · Kargo bedava' : 'Kargo bedava · Kapıda ödeme');
    yaz('[data-kp-alt]', adet + ' · ' + (k ? 'tanesi ' + tl(p.price / p.adet) + ' · ' : '') + 'Kargo bedava · Kapıda ödeme');
    $$('.cip').forEach(function (b) { var i = Array.prototype.indexOf.call(b.parentNode.children, b); b.setAttribute('aria-checked', String(i === idx)); });
    $$('.m-paket').forEach(function (b, i) { b.setAttribute('aria-checked', String(i === idx)); });
    yaz('[data-oz-paket]', adet + ' ' + URUN);
    var ob = $('[data-odeme]'); if (ob) ob.disabled = p.available === false;
  }
  function sec(i) {
    if (!PK[i]) return; idx = i; guncelle();
    document.dispatchEvent(new CustomEvent('ost:paket', { detail: { adet: PK[i].adet, fiyat: PK[i].price } }));
  }

  /* ---------------- Basit hesap ---------------- */
  function hesap() {
    var iki = PK.filter(function (p) { return p.adet === 2; })[0]; if (!iki) return;
    yaz('[data-hesap-iki]', tl(birim * 2));
    yaz('[data-hesap-paket]', tl(iki.price));
    yaz('[data-hesap-tane]', 'tanesi ' + tl(iki.price / 2) + ' · kargo bedava');
    yaz('[data-hesap-kazanc]', tl(kazanc(iki)));
    yaz('[data-hesap-yuzde]', '-%' + yuzde(iki));
    yaz('[data-tane-iki]', tl(iki.price / 2));
  }

  /* ---------------- Takip ---------------- */
  var UA = navigator.userAgent || '';
  var CIHAZ = /iPhone|iPad|iPod/i.test(UA) ? 'iOS' : /Android/i.test(UA) ? 'Android' : 'Masaustu';
  var TARAYICI = /Instagram/i.test(UA) ? 'Instagram' : /FBAN|FBAV|FB_IAB|FBIOS|Messenger/i.test(UA) ? 'Facebook' : /musical_ly|BytedanceWebview|TikTok/i.test(UA) ? 'TikTok' : /SamsungBrowser/i.test(UA) ? 'Samsung' : /CriOS|Chrome/i.test(UA) ? 'Chrome' : /Safari/i.test(UA) ? 'Safari' : 'Diger';
  function piksel(ad, veri) {
    try { if (window.fbq) window.fbq('track', ad, veri || {}); } catch (e) {}
    try { if (window.ttq) window.ttq.track(ad, veri || {}); } catch (e) {}
  }
  function izle(ad, veri) {
    var v = { tarayici: TARAYICI, cihaz: CIHAZ, urun: '3in1' }; for (var k in (veri || {})) v[k] = veri[k];
    try { if (window.fbq) window.fbq('trackCustom', 'OST_' + ad, v); } catch (e) {}
    try { if (window.gtag) window.gtag('event', 'ost_' + ad.toLowerCase(), v); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ost_' + ad.toLowerCase(), v); } catch (e) {}
  }
  window.OST_IZLE = izle;

  /* ---------------- Çalışma şekli ---------------- */
  var MOD = CFG.mode === 'shopify' ? 'shopify' : 'yaprak';
  $$('[data-mod]').forEach(function (el) { el.hidden = el.getAttribute('data-mod') !== MOD; });

  /* ---------------- Sipariş modalı ---------------- */
  var modal = modalEl, sonOdak = null, ilerledi = false, yakalandi = false;
  try { yakalandi = sessionStorage.getItem('ost_yk') === '1'; } catch (e) {}
  function formUrl() {
    var p = PK[idx] || {}; var u = p.formUrl || CFG.fallbackFormUrl || '';
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'paket=' + (p.adet || 1);
  }
  function formYukle() {
    if (MOD !== 'yaprak') return;
    var yuva = $('[data-form-yuva]'), url = formUrl(); if (!yuva || !url) return;
    var fr = $('iframe', yuva), yer = $('[data-form-yer]', yuva); if (yer) yer.hidden = true;
    if (!fr) { fr = document.createElement('iframe'); fr.id = 'stoktv-order-frame'; fr.title = URUN + ' sipariş formu'; yuva.appendChild(fr); }
    if (fr.getAttribute('src') !== url) fr.setAttribute('src', url);
  }
  function kilit(ac) { document.documentElement.classList.toggle('ost-kilit', ac); }
  function pencereAc(el) { if (!el) return; sonOdak = sonOdak || document.activeElement; el.classList.add('acik'); el.setAttribute('aria-hidden', 'false'); kilit(true); setTimeout(function () { var k = el.querySelector('button'); k && k.focus({ preventScroll: true }); }, 60); }
  function pencereKapat(el) {
    if (!el) return;
    el.classList.remove('acik'); el.setAttribute('aria-hidden', 'true');
    if (!$$('.modal.acik, .yakala.acik').length) { kilit(false); if (sonOdak && sonOdak.focus) sonOdak.focus({ preventScroll: true }); sonOdak = null; }
  }
  function ac() { pencereAc(modal); formYukle(); guncelle(); izle('ModalAc', { paket: PK[idx].adet }); piksel('InitiateCheckout', { value: PK[idx].price, currency: 'TRY' }); }
  function kapat() {
    pencereKapat(modal);
    if (!ilerledi && !yakalandi && CFG.whatsapp) {
      yakalandi = true; try { sessionStorage.setItem('ost_yk', '1'); } catch (e) {}
      setTimeout(function () { pencereAc($('[data-yakala]')); izle('KapanisYakala', {}); }, 250);
    }
  }
  $$('.js-siparis').forEach(function (b) { b.addEventListener('click', function () { if (b.closest('[data-yakala]')) pencereKapat($('[data-yakala]')); ac(); }); });
  $$('[data-sec-paket]').forEach(function (b) { b.addEventListener('click', function () { sec(+b.getAttribute('data-sec-paket')); ac(); }); });
  $$('[data-kapat]', modal).forEach(function (b) { b.addEventListener('click', kapat); });
  $$('[data-yakala-kapat]').forEach(function (b) { b.addEventListener('click', function () { pencereKapat($('[data-yakala]')); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var wa = $('[data-wa-modal].acik'), yk = $('[data-yakala].acik');
    if (wa) pencereKapat(wa); else if (yk) pencereKapat(yk); else if (modal.classList.contains('acik')) kapat();
  });

  /* stoktv köprüsü: form yüksekliği + pixel olaylarını ilet */
  window.addEventListener('message', function (e) {
    if (!/stoktv\.site$/.test((e.origin || '').replace(/^https?:\/\/(www\.)?/, '').split(':')[0])) return;
    var d = e.data || {};
    if (d.type === 'setHeight' && typeof d.height === 'number') { var fr = document.getElementById('stoktv-order-frame'); if (fr) fr.style.height = d.height + 'px'; }
    if (d.type === 'pixelEvent' && d.event) { piksel(d.event, d.data); if (d.event === 'Purchase') ilerledi = true; }
  });

  /* ---------------- SHOPIFY: doğrudan ödeme (/cart/VARYANT:1) ---------------- */
  function odemeLinki(vid) {
    var kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return kok + 'cart/' + vid + ':1?attributes%5BTarayici%5D=' + encodeURIComponent(TARAYICI + ' / ' + CIHAZ);
  }
  var odemeBtn = $('[data-odeme]');
  if (odemeBtn) odemeBtn.addEventListener('click', function () {
    var p = PK[idx]; if (!p || !p.vid || p.available === false) return;
    ilerledi = true; izle('OdemeTikla', { paket: p.adet, fiyat: p.price });
    var eski = odemeBtn.innerHTML, gitti = false, kurtar = $('[data-odeme-kurtar]');
    odemeBtn.disabled = true; odemeBtn.innerHTML = '<span>Ödeme sayfası açılıyor…</span>'; kurtar.hidden = true;
    window.addEventListener('pagehide', function () { gitti = true; }, { once: true });
    document.addEventListener('visibilitychange', function v() { if (document.hidden) { gitti = true; document.removeEventListener('visibilitychange', v); } });
    location.href = odemeLinki(p.vid);
    setTimeout(function () {
      if (gitti) return;
      odemeBtn.disabled = false; odemeBtn.innerHTML = eski; guncelle();
      izle('OdemeTakildi', { paket: p.adet });
      kurtar.innerHTML = '<b>Ödeme sayfası açılmadı mı?</b><small>Bağlantın yavaş olabilir. Tekrar dene ya da siparişini WhatsApp\'tan 30 saniyede ver.</small><a href="' + odemeLinki(p.vid) + '">Ödeme sayfasını aç</a>' + (CFG.whatsapp ? '<button type="button" class="ok-wa" data-wa-ac>WhatsApp\'tan sipariş ver</button>' : '');
      kurtar.hidden = false;
    }, 6000);
  });

  /* ---------------- WHATSAPP ---------------- */
  function waLink(m) { return 'https://wa.me/' + CFG.whatsapp + '?text=' + encodeURIComponent(m); }
  function waAcUrl(url) { if (CIHAZ !== 'Masaustu') { location.href = url; return; } var w = null; try { w = window.open(url, '_blank'); } catch (e) {} if (!w) location.href = url; }
  if (!CFG.whatsapp) { $$('[data-wa-ac], .m-ya').forEach(function (b) { b.hidden = true; }); }
  else {
    $$('[data-wa-link]').forEach(function (a) { a.hidden = false; a.href = waLink('Merhaba, ' + URUN + ' spreyli cam temizleme fırçası hakkında bilgi almak istiyorum.'); a.target = '_blank'; a.rel = 'noopener'; a.addEventListener('click', function () { izle('WhatsAppLink', {}); }); });
    var yz = $('.wa-yuzen'); if (yz) { setTimeout(function () { yz.classList.add('genis'); setTimeout(function () { yz.classList.remove('genis'); }, 6000); }, 9000); }
  }
  var waM = $('[data-wa-modal]'), waForm = $('[data-wa-form]');
  function waCiz() {
    var p = PK[idx];
    $('[data-wf-paketler]').innerHTML = PK.map(function (x, i) {
      return '<button type="button" data-wf-pkt="' + i + '" class="' + (i === idx ? 'sec' : '') + '">' + (x.best ? '<em>EN AVANTAJLI</em>' : '') + '<b>' + x.adet + ' Adet</b><small>' + tl(x.price) + '</small></button>';
    }).join('');
    $('[data-wa-ozet]').textContent = '📦 ' + p.adet + ' Adet ' + URUN + ' · ' + tl(p.price) + ' · Kapıda ödeme · Kargo bedava';
  }
  function waAc() {
    if (!waM || !CFG.whatsapp) return;
    ilerledi = true; waCiz(); izle('WhatsAppForm', { paket: PK[idx].adet });
    var d = new Date(), iki = function (x) { return (x < 10 ? '0' : '') + x; };
    $('[data-wa-saat]').textContent = iki(d.getHours()) + ':' + iki(d.getMinutes());
    $('[data-wf-err]').hidden = true;
    pencereAc(waM);
    setTimeout(function () { var f = waForm.querySelector('[name="ad"]'); if (f && !f.value) try { f.focus({ preventScroll: true }); } catch (e) {} }, 350);
  }
  KOK.addEventListener('click', function (e) {
    if (e.target.closest('[data-wa-ac]')) { e.preventDefault(); if (e.target.closest('[data-yakala]')) pencereKapat($('[data-yakala]')); waAc(); return; }
    var pk = e.target.closest('[data-wf-pkt]'); if (pk) { sec(+pk.getAttribute('data-wf-pkt')); waCiz(); }
  });
  $$('[data-wa-kapat]').forEach(function (b) { b.addEventListener('click', function () { pencereKapat(waM); }); });
  if (waForm) {
    var tel = waForm.querySelector('[name="tel"]');
    tel.addEventListener('input', function () {
      var d = this.value.replace(/\D/g, '');
      if (d.slice(0, 2) === '90') d = d.slice(2);
      if (d.charAt(0) === '0') d = d.slice(1);
      d = d.slice(0, 10);
      var o = '';
      if (d.length) { o = '0' + d.slice(0, 3); if (d.length > 3) o += ' ' + d.slice(3, 6); if (d.length > 6) o += ' ' + d.slice(6, 8); if (d.length > 8) o += ' ' + d.slice(8, 10); }
      this.value = o;
    });
    waForm.addEventListener('input', function (e) { if (e.target.value && e.target.value.trim()) e.target.classList.remove('wf-eksik'); if (!waForm.querySelector('.wf-eksik')) $('[data-wf-err]').hidden = true; });
    waForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var g = function (n) { return waForm.querySelector('[name="' + n + '"]').value.trim(); };
      var eksik = false;
      ['ad', 'soyad', 'tel', 'il', 'ilce', 'adres'].forEach(function (n) { var el = waForm.querySelector('[name="' + n + '"]'), bos = !el.value.trim(); el.classList.toggle('wf-eksik', bos); if (bos) eksik = true; });
      var telD = g('tel').replace(/\D/g, ''); if (telD.slice(0, 2) === '90') telD = telD.slice(2); if (telD.charAt(0) === '0') telD = telD.slice(1);
      var telOk = /^5\d{9}$/.test(telD); if (!telOk) tel.classList.add('wf-eksik');
      var err = $('[data-wf-err]');
      if (eksik || !telOk) {
        err.textContent = (!telOk && !eksik) ? "Telefon numaranı kontrol et: 0'dan sonra 5 ile başlayan 10 hane olmalı (örn. 0532 123 45 67)." : 'Lütfen kırmızı işaretli alanları doldur.';
        err.hidden = false; var ilk = waForm.querySelector('.wf-eksik'); if (ilk) try { ilk.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) {}
        if (navigator.vibrate) navigator.vibrate([10, 40, 10]);
        return;
      }
      var p = PK[idx], telFmt = '0' + telD.slice(0, 3) + ' ' + telD.slice(3, 6) + ' ' + telD.slice(6, 8) + ' ' + telD.slice(8, 10);
      izle('WhatsAppGonder', { paket: p.adet, fiyat: p.price }); piksel('Lead', { value: p.price, currency: 'TRY' });
      waAcUrl(waLink('Merhaba 👋 Siparişimi tamamlamak istiyorum:\n'
        + '📦 Ürün: Olinman 3 in 1 Spreyli Cam Temizleme Fırçası\n'
        + '🔢 Paket: ' + p.adet + ' Adet — ' + tl(p.price) + '\n'
        + '👤 Ad Soyad: ' + g('ad') + ' ' + g('soyad') + '\n'
        + '📞 Telefon: ' + telFmt + '\n'
        + '📍 Adres: ' + g('adres') + ' — ' + g('ilce') + ' / ' + g('il') + '\n'
        + '🚚 Kargo: Ücretsiz\n'
        + '💵 Ödeme: Kapıda ödeme (teslimatta)'));
      pencereKapat(waM);
    });
  }

  /* ---------------- Hero galeri ---------------- */
  var ana = $('[data-hg-ana]');
  $$('[data-hg]').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('[data-hg]').forEach(function (x) { x.classList.toggle('aktif', x === b); });
      ana.style.opacity = .25;
      setTimeout(function () { ana.src = b.getAttribute('data-hg'); ana.style.opacity = 1; }, 140);
      izle('Galeri', { gorsel: b.getAttribute('aria-label') });
    });
  });

  /* ---------------- Saplı / el tipi ---------------- */
  var sapG = $('[data-sap-gorsel]');
  $$('[data-sap]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-sap');
      $$('[data-sap]').forEach(function (x) { x.classList.toggle('aktif', x === b); x.setAttribute('aria-selected', String(x === b)); });
      $$('[data-sap-metin]').forEach(function (m) { m.hidden = m.getAttribute('data-sap-metin') !== k; });
      sapG.style.opacity = .3; var yeni = b.getAttribute('data-sap-img'); setTimeout(function () { if (yeni) sapG.src = yeni; sapG.style.opacity = 1; }, 140);
    });
  });

  /* ---------------- Kargo sayacı (gerçek): bugün ver → ertesi gün kargoda ----------------
     shipCutoffHour: bu saate kadar verilen sipariş ertesi gün kargoya verilir (24 = gün sonu).
     shipSaturday: true → cumartesi de kargo çıkar. Pazar kargo yok. */
  var GUN = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  var AY = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  function kargoGunuMu(d) { return d.getDay() !== 0 && (d.getDay() !== 6 || CFG.shipSaturday !== false); }
  function sonrakiKargoGunu(d) { var x = new Date(d); do { x.setDate(x.getDate() + 1); } while (!kargoGunuMu(x)); return x; }
  function teslimGunu(d) { var x = new Date(d); do { x.setDate(x.getDate() + 1); } while (x.getDay() === 0); return x; }
  function kargo() {
    var simdi = new Date(), saat = +CFG.shipCutoffHour || 24;
    var son = new Date(simdi); son.setHours(0, 0, 0, 0); son.setTime(son.getTime() + saat * 3600000);   /* bugünün kesim anı */
    var siparisGunu = new Date(simdi);
    if (simdi >= son) { son.setDate(son.getDate() + 1); siparisGunu.setDate(siparisGunu.getDate() + 1); }
    var kargoGunu = sonrakiKargoGunu(siparisGunu);
    var bugun = new Date(simdi); bugun.setHours(12, 0, 0, 0);
    var fark = Math.round((new Date(kargoGunu).setHours(12, 0, 0, 0) - bugun) / 86400000);
    var gunAd = fark === 1 ? 'Yarın' : GUN[kargoGunu.getDay()];
    var s = Math.floor(Math.max(0, son - simdi) / 1000);
    var hh = String(Math.floor(s / 3600)).padStart(2, '0'), mm = String(Math.floor(s % 3600 / 60)).padStart(2, '0'), ss = String(s % 60).padStart(2, '0');
    yaz('[data-sayac]', hh + ':' + mm + ':' + ss);
    yaz('[data-kargo-gun]', gunAd);
    var t1 = teslimGunu(kargoGunu), t3 = teslimGunu(teslimGunu(t1));
    yaz('[data-teslim-tarih]', t1.getMonth() === t3.getMonth() ? t1.getDate() + '–' + t3.getDate() + ' ' + AY[t3.getMonth()] : t1.getDate() + ' ' + AY[t1.getMonth()] + ' – ' + t3.getDate() + ' ' + AY[t3.getMonth()]);
    var kutu = $('[data-sayac-kutu] span'); if (kutu) kutu.textContent = gunAd + ' kargoda olması için kalan süre';
    var satir = $('[data-kargo-satir] span');
    if (satir) satir.innerHTML = '<b>' + (+hh) + ' sa ' + (+mm) + ' dk</b> içinde sipariş ver, <b>' + gunAd.toLocaleLowerCase('tr-TR') + ' kargoda</b>';
  }

  /* ---------------- Yorumlar (yalnız gerçek veri) ---------------- */
  function yorumlar() {
    var r = CFG.reviews || []; if (!r.length) return;
    var kap = $('[data-yorum-liste]'); $('[data-yorumlar]').hidden = false;
    r.forEach(function (y) {
      var d = document.createElement('article'); d.className = 'yorum';
      var yild = ''; for (var i = 0; i < 5; i++) yild += '<svg style="opacity:' + (i < y.stars ? 1 : .25) + '"><use href="#o-star"/></svg>';
      d.innerHTML = '<div class="yorum-yildiz">' + yild + '</div><p></p><div class="yorum-kim"><span class="yorum-av"></span><span><b></b></span></div>';
      $('p', d).textContent = y.text;
      $('.yorum-av', d).textContent = (y.name || '?').charAt(0);
      $('.yorum-kim b', d).textContent = y.name;
      $('.yorum-kim span:last-child', d).appendChild(document.createTextNode([y.bought, y.city].filter(Boolean).join(' · ')));
      kap.appendChild(d);
    });
  }

  /* ---------------- Kaydırma: ilerleme + dock ---------------- */
  var bar = $('.ilerleme span'), dock = $('[data-alt-bar]'), hero = $('#hero');
  function kaydir() {
    var h = document.documentElement, oran = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight);
    if (bar) bar.style.width = (oran * 100).toFixed(1) + '%';
    var goster = window.scrollY > Math.min(380, (hero ? hero.offsetHeight : 800) * 0.4);
    if (dock) { dock.classList.toggle('acik', goster); KOK.classList.toggle('dock-acik', goster); }
  }
  window.addEventListener('scroll', kaydir, { passive: true });

  cipleriCiz(); guncelle(); hesap(); yorumlar(); kargo(); kaydir();
  setInterval(kargo, 1000);
  piksel('ViewContent');
})();

/* =========================================================================
   EFEKTLER — belirme, parallax, sayaç, damlalar, eğim, dalga, kaydırma
   noktaları, "buğulu camı sil" oyunu
   ========================================================================= */
(function () {
  'use strict';
  var KOK = document.querySelector('.ost26'); if (!KOK) return;
  var $ = function (s, k) { return (k || KOK).querySelector(s); };
  var $$ = function (s, k) { return Array.prototype.slice.call((k || KOK).querySelectorAll(s)); };
  var azHareket = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var izle = window.OST_IZLE || function () {};

  /* --- Kaydırınca belirme (gizleme yalnız JS çalışınca: html.ost-js) --- */
  var rv = $$('.rv');
  rv.forEach(function (el) {
    var kardes = el.parentNode ? Array.prototype.filter.call(el.parentNode.children, function (x) { return x.classList.contains('rv'); }) : [];
    var i = kardes.indexOf(el); if (i > 0) el.style.setProperty('--rv-gec', Math.min(i, 5) * 0.08 + 's');
  });
  var bekleyen = rv.slice();
  function belirt() {
    var vh = window.innerHeight, vw = window.innerWidth;
    bekleyen = bekleyen.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.94 && r.bottom > -vh && r.left < vw * 1.5) { el.classList.add('gorundu'); return false; }
      return true;
    });
  }
  if (azHareket) rv.forEach(function (el) { el.classList.add('gorundu'); });
  else {
    var rb = false;
    var tetik = function () { if (!rb) { rb = true; requestAnimationFrame(function () { rb = false; belirt(); }); } };
    window.addEventListener('scroll', tetik, { passive: true }); window.addEventListener('resize', belirt);
    $$('[data-kaydir]').forEach(function (k) { k.addEventListener('scroll', tetik, { passive: true }); });
    belirt(); setTimeout(belirt, 400);
    setTimeout(function () { rv.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('gorundu'); }); }, 2500);
  }

  /* --- Parallax --- */
  var px = $$('img[data-parallax]'), bekle = false;
  function parallax() {
    bekle = false; var vh = window.innerHeight;
    px.forEach(function (im) {
      var r = im.parentNode.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var o = ((r.top + r.height / 2) - vh / 2) / vh;
      im.style.transform = 'scale(1.12) translateY(' + (o * -20).toFixed(1) + 'px)';
    });
  }
  if (!azHareket && px.length) { window.addEventListener('scroll', function () { if (!bekle) { bekle = true; requestAnimationFrame(parallax); } }, { passive: true }); parallax(); }

  /* --- Sayılar sayarak gelsin --- */
  $$('[data-say]').forEach(function (el) {
    var hedef = +el.getAttribute('data-say'); if (!hedef || azHareket || !('IntersectionObserver' in window)) return;
    el.textContent = '0';
    var o = new IntersectionObserver(function (g) {
      if (!g[0].isIntersecting) return; o.disconnect();
      var t0 = performance.now();
      (function adim(t) { var p = Math.min(1, (t - t0) / 1100); el.textContent = Math.round(hedef * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(adim); })(t0);
    }, { threshold: .6 });
    o.observe(el);
  });

  /* --- Süzülen su damlaları --- */
  if (!azHareket) $$('[data-damla]').forEach(function (k) {
    for (var i = 0; i < 14; i++) {
      var b = document.createElement('i'), s = 6 + Math.random() * 16;
      b.style.cssText = 'width:' + s + 'px;height:' + (s * 1.25) + 'px;left:' + (Math.random() * 96) + '%;animation-duration:' + (6 + Math.random() * 7).toFixed(1) + 's;animation-delay:' + (-Math.random() * 10).toFixed(1) + 's';
      k.appendChild(b);
    }
  });

  /* --- Hero görsel eğimi (masaüstü) --- */
  var tilt = $('[data-tilt]');
  if (tilt && !azHareket && window.matchMedia('(hover:hover)').matches) {
    tilt.addEventListener('pointermove', function (e) {
      var r = tilt.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      tilt.style.transform = 'perspective(900px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 7).toFixed(2) + 'deg)';
    });
    tilt.addEventListener('pointerleave', function () { tilt.style.transform = ''; });
  }

  /* --- Butonlarda tıklama dalgası --- */
  KOK.addEventListener('pointerdown', function (e) {
    var b = e.target.closest('.btn, .dock-cta, .m-wa, .wa-gonder, .oyun-sik'); if (!b) return;
    var r = b.getBoundingClientRect(), d = Math.max(r.width, r.height), s = document.createElement('span');
    s.className = 'dalga'; s.style.cssText = 'width:' + d + 'px;height:' + d + 'px;left:' + (e.clientX - r.left - d / 2) + 'px;top:' + (e.clientY - r.top - d / 2) + 'px';
    b.appendChild(s); setTimeout(function () { s.remove(); }, 650);
  });

  /* --- Kaydırma noktaları --- */
  $$('[data-kaydir]').forEach(function (k) {
    var n = k.parentNode.querySelector('[data-kaydir-nokta]'); if (!n) return;
    var kartlar = Array.prototype.slice.call(k.children);
    n.innerHTML = kartlar.map(function (_, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('');
    k.addEventListener('scroll', function () {
      var i = Math.round(k.scrollLeft / (kartlar[0].offsetWidth + 12));
      Array.prototype.forEach.call(n.children, function (d, j) { d.classList.toggle('on', j === i); });
    }, { passive: true });
  });

  /* --- OYUN: buğulu camı sil --- */
  var oy = $('[data-oyun]');
  if (oy) {
    var tv = $('[data-oyun-tuval]', oy), ctx = tv.getContext('2d'), ip = $('[data-oyun-ipucu]', oy), yb = $('[data-oyun-yuzde]', oy),
      sis = $('[data-oyun-sis]', oy), im = $('[data-oyun-imlec]', oy), sikBtn = $('[data-oyun-sik]', oy),
      bitti = false, ciz = false, son = null, sayac = 0, basladi = false, islak = false;
    function bugu() {
      var r = oy.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
      tv.width = Math.round(r.width * dpr); tv.height = Math.round(r.height * dpr);
      var w = tv.width, h = tv.height;
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, 0, h); g.addColorStop(0, 'rgba(214,226,228,.97)'); g.addColorStop(1, 'rgba(188,204,207,.98)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      for (var i = 0; i < 1400; i++) {   /* buğu damlacıkları + kireç lekeleri */
        var x = Math.random() * w, y = Math.random() * h, s = (Math.random() * Math.random()) * 9 * dpr + .6;
        ctx.fillStyle = i % 7 === 0 ? 'rgba(255,255,255,.55)' : i % 5 === 0 ? 'rgba(150,165,160,.35)' : 'rgba(235,242,243,.5)';
        ctx.beginPath(); ctx.arc(x, y, s, 0, Math.PI * 2); ctx.fill();
      }
      for (var j = 0; j < 26; j++) {   /* süzülmüş su izleri */
        var sx = Math.random() * w, sy = Math.random() * h * .6;
        ctx.strokeStyle = 'rgba(170,186,188,.45)'; ctx.lineWidth = (1 + Math.random() * 2.5) * dpr;
        ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(sx + (Math.random() - .5) * 8 * dpr, sy + (40 + Math.random() * 140) * dpr); ctx.stroke();
      }
      ctx.globalCompositeOperation = 'destination-out';
    }
    function nokta(e) { var r = tv.getBoundingClientRect(); return { x: (e.clientX - r.left) * tv.width / r.width, y: (e.clientY - r.top) * tv.height / r.height, cx: e.clientX - r.left, cy: e.clientY - r.top }; }
    function sil(p) {
      /* silecek başlığı: geniş yatay şerit (ıslakken daha geniş ve net) */
      var bw = tv.width * (islak ? 0.34 : 0.26), bh = tv.height * 0.055;
      ctx.fillStyle = '#000';
      var adimlar = son ? Math.max(1, Math.ceil(Math.hypot(p.x - son.x, p.y - son.y) / (bh * 0.4))) : 1;
      for (var i = 1; i <= adimlar; i++) {
        var t = i / adimlar, x = son ? son.x + (p.x - son.x) * t : p.x, y = son ? son.y + (p.y - son.y) * t : p.y;
        ctx.beginPath();
        if (ctx.roundRect) ctx.roundRect(x - bw / 2, y - bh / 2, bw, bh, bh / 2); else ctx.rect(x - bw / 2, y - bh / 2, bw, bh);
        ctx.fill();
      }
      son = p;
      im.style.transform = 'translate(' + p.cx + 'px,' + p.cy + 'px)';
      if (++sayac % 6 === 0) olc();
    }
    function olc() {
      var d = ctx.getImageData(0, 0, tv.width, tv.height).data, bos = 0, top = 0;
      for (var i = 3; i < d.length; i += 64) { top++; if (d[i] < 40) bos++; }
      var y = Math.round(bos / top * 100); yb.style.width = Math.min(100, Math.round(y / 60 * 100)) + '%';
      if (y >= 60 && !bitti) {
        bitti = true; oy.classList.add('bitti'); $('[data-oyun-sonuc]', oy).hidden = false;
        ctx.clearRect(0, 0, tv.width, tv.height);
        if (navigator.vibrate) navigator.vibrate(30);
        izle('OyunBitti', {});
      }
    }
    sikBtn.addEventListener('click', function () {
      if (bitti) return;
      islak = true; oy.classList.add('islak');
      sis.classList.remove('puskur'); void sis.offsetWidth; sis.classList.add('puskur');
      ip.innerHTML = 'Şimdi parmağınla <b>sağa sola sıyır</b>';
      izle('OyunSik', {});
    });
    tv.addEventListener('pointerdown', function (e) {
      if (bitti) return; ciz = true; son = null; ip.classList.add('gizli'); oy.classList.add('siliyor');
      if (!basladi) { basladi = true; izle('OyunBasla', {}); }
      try { tv.setPointerCapture(e.pointerId); } catch (x) {}
      sil(nokta(e));
    });
    tv.addEventListener('pointermove', function (e) { if (ciz) sil(nokta(e)); });
    /* iOS/Android: oyun bitene kadar camın üstünde sayfa kaymasın (silerken ekran oynamasın) */
    ['touchstart', 'touchmove'].forEach(function (t) { tv.addEventListener(t, function (e) { if (!bitti && e.cancelable) e.preventDefault(); }, { passive: false }); });
    ['pointerup', 'pointercancel'].forEach(function (t) { tv.addEventListener(t, function () { ciz = false; son = null; oy.classList.remove('siliyor'); olc(); }); });
    bugu();
    var genislik = oy.offsetWidth;
    window.addEventListener('resize', function () { if (!bitti && !basladi && Math.abs(oy.offsetWidth - genislik) > 40) { genislik = oy.offsetWidth; bugu(); } });
  }
})();
